/**
 * Held until Dugger authorizes the broker-platform TRACK release.
 * TO ENABLE: set true and have an operator dispatch deploy-driver-portal.yml.
 */
export const DRIVER_PASSKEYS_ENABLED = false

/**
 * Held until Dugger authorizes the broker-platform TRACK release.
 * TO ENABLE: set true and have an operator dispatch deploy-driver-portal.yml.
 */
export const PICKUP_CAPTURE_ENABLED = false
